import React, { useEffect, useState } from "react";
import { Row, Col, Empty, Spin } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import DocumentCard from "./DocumentCard";

const PAGE = 24;

// Mostra i documenti filtrati a blocchi (infinite scroll) per limitare le anteprime montate.
const DocumentsGrid = ({
  docs,
  selected,
  onToggleSelect,
  onOpen,
  cardsPerRow = 4,
  showPreview = true,
  selectable = true,
  showOrgLink = true,
  showFlags = false,
  emptyDescription = "Nessun documento corrisponde ai filtri",
}) => {
  const [count, setCount] = useState(PAGE);

  // Reset della paginazione quando cambia il set filtrato.
  useEffect(() => {
    setCount(PAGE);
  }, [docs]);

  if (!docs.length) {
    return <Empty description={emptyDescription} />;
  }

  const visible = docs.slice(0, count);
  const span = Math.max(2, Math.round(24 / cardsPerRow));

  return (
    <InfiniteScroll
      dataLength={visible.length}
      next={() => setCount((c) => c + PAGE)}
      hasMore={count < docs.length}
      loader={<div style={{ textAlign: "center", padding: 16 }}><Spin /></div>}
      style={{ overflow: "visible" }}
    >
      <Row gutter={[16, 16]} align="stretch">
        {visible.map((doc) => (
          <Col xs={24} sm={12} md={span} key={doc.objectId}>
            <DocumentCard
              doc={doc}
              selected={selected.has(doc.objectId)}
              onToggleSelect={onToggleSelect}
              onOpen={onOpen}
              showPreview={showPreview}
              selectable={selectable}
              showOrgLink={showOrgLink}
              showFlags={showFlags}
            />
          </Col>
        ))}
      </Row>
    </InfiniteScroll>
  );
};

export default DocumentsGrid;
